<template>
  <div class="">
    <button class="btn-indigo w-32 font-normal" @click="openModal()">Card</button>
    <ModalHeadlessUI ref="modal">
      <template #default>
        <h1 class="font-bold mb-4 text-3xl text-center">
          Mail Card
        </h1>
        <div class="px-10">
          <form id="form" name="form" @submit.prevent="sendCard">
            <text-input v-model="form.to" :error="form.errors.to" class="pr-6 pb-4 w-full" label="Addressed To" />
            <text-input v-model="form.address" :zillow="zillow" :error="form.errors.address" class="relative pr-6 pb-4 w-full" label="Address" />
            <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-4 w-full" label="City" />
            <text-input v-model="form.state" :error="form.errors.state" class="pr-6 pb-4 w-full" label="State" />
            <text-input v-model="form.zip" :error="form.errors.zip" class="pr-6 pb-4 w-full" label="Zip" />
            <select-input v-model="form.font" class="pr-6 pb-4 w-full" label="Select Handwriting Font">
              <option value="Casual David" selected="selected">Casual David (Dude)</option>
              <option value="Enthusiastic Erin">Enthusiastic Erin (Chick)</option>
            </select-input>
            <select-input v-model="form.message" class="pr-6 pb-4 w-full" label="Select Card Template">
              <option :value="null" />
              <option v-for="cardTemplateSingle in cardTemplateOptions" :key="cardTemplateSingle.id" :value="cardTemplateSingle.value">{{ cardTemplateSingle.name }}</option>
            </select-input>
            <textarea-input v-model="form.message" rows="10" :error="form.errors.message" class="pr-6 pb-4 w-full" label="Message">Card Message</textarea-input>
            <div class="flex justify-center items-center mt-5">
              <div>
                <loading-button :loading="form.processing" class="cursor-pointer btn-indigo ml-auto" type="submit">Send Card</loading-button>
              </div>
            </div>
          </form>
        </div>
      </template>
    </ModalHeadlessUI>
  </div>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
  import { router } from '@inertiajs/vue3'

export default {
  components: {
    ModalHeadlessUI,
    SelectInput,
    TextareaInput,
    TextInput,
    LoadingButton,
  },
  props: {
    lead:{
      type: Object,
      default: null,
    },
    userInfo:{
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: router.form({
        id: this.lead.id,
        type: 'lead',
        to: this.lead.fullName,
        address: this.lead.address,
        city: this.lead.city,
        state: this.lead.state,
        zip: this.lead.zip,
        font: 'Casual David',
        message: '',
      }),
    }
  },
  computed:{
    firstName(){
      if(this.lead.fullNameCoborrower == ''){
        let fullName = this.lead.fullName.trim().split(' ')
        return fullName[0]
      }
      else{
        let fullName = this.lead.fullName.trim().split(' ')
        let fullNameCoborrower = this.lead.fullNameCoborrower.trim().split(' ')
        return fullName[0] +' & '+fullNameCoborrower[0]
      }
    },
    cardTemplateOptions() {
      var cardTemplateOptions= [
        {
          'id': '1',
          'name': 'Closing Thank You',
          'value':  this.firstName+',\n\nThank you so much for putting trust in us to assist you with your Mortgage! Please remember that we are here to help with anything that you may need now and in the future! \n\nSincerely,\n'+this.userInfo.user_first_name+' '+this.userInfo.user_last_name+'\nand the Riverbank Finance Team',
        },
        {
          'id': '2',
          'name': 'Pre-Approval',
          'value':  this.firstName+',\n\nCongratulations on your Mortgage Pre-Approval!\nI look forward to helping you buy your home!\n\nYour Loan Officer,\n'+this.userInfo.user_first_name+' '+this.userInfo.user_last_name+'\n'+this.userInfo.user_phone+'\nRiverbank Finance',
        },
        {
          'id': '3',
          'name': 'Referral',
          'value':  this.firstName+',\n\nThank you for trusting me with a referral. I greatly appreciate you sending clients my way to help with their home loans!\nSincerely,\n'+this.userInfo.user_first_name+' '+this.userInfo.user_last_name+'\n'+this.userInfo.user_phone+'\nRiverbank Finance',
        },
        {
          'id': '4',
          'name': 'Realtor',
          'value':  this.firstName+',\n\nI wanted to send you a quick card to check in. I hope you are crushing this year! If there is anything I can do to help you grow your business let me know!\n\nSincerely,\n'+this.userInfo.user_first_name+' '+this.userInfo.user_last_name+'\n'+this.userInfo.user_phone+'\nRiverbank Finance',
        },
      ]
      return cardTemplateOptions
    },
  },
  methods:{
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    sendCard() {
      this.form.post('/card', {
        onSuccess: () => {
          this.closeModal()
        },
      })
    },
  },
}
</script>
